import { Navigate, Outlet, useLocation } from "react-router-dom";
import { Spinner } from "@/components/ui/spinner";
import { useAuth } from "@/hooks/use-auth";
import { ContentLayout } from "@/components/layouts";

export function AuthLayout() {
    const { user, claims, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return (
            <div className="flex h-screen w-screen items-center justify-center">
                <Spinner size="md" />
            </div>
        );
    }

    if (!user || !user.emailVerified) {
        return <Navigate to={!user ? "/" : "/verify-email"} replace />;
    }

    if (claims === "clinician" && location.pathname.startsWith("/patient")) {
        return <Navigate to="/clinician" replace />;
    }

    if (claims === "patient" && location.pathname.startsWith("/clinician")) {
        return <Navigate to="/patient/manage" replace />;
    }

    return (
        <ContentLayout authLayout={true}>
            <Outlet />
        </ContentLayout>
    );
}
